var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTravel = function SvgTravel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#045BA6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.547 15.382-5.816-.732-2.04 1.428 3.872 2.094",
    stroke: "#fff",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m22.325 14.766 2.052-1.497a5.29 5.29 0 0 1 5.3-.544l-2.402 1.86a4 4 0 0 1-3.82.594l-1.13-.413Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m20.284 21.778-2.569 1.799a2.917 2.917 0 0 1-3.323.016l-2.603-1.785a.73.73 0 0 1-.006-1.199l.799-.559a.73.73 0 0 1 .765-.044l.628.34c.41.222.783-.056.783-.056s9.168-6.386 10.76-7.517c1.326-.943 2.952-.699 3.994-.238 1.104.489 1.178 1.367.841 1.995-.111.208-.27.387-.464.522l-5.165 3.617.205 5.271c.02.495-.215.967-.62 1.251l-1 .7a.73.73 0 0 1-1.09-.312l-2.056-4.99",
    stroke: "#fff",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "m11.986 27.589 2.047-1.434M14.341 29.5l4.778-3.346M9.63 25.678l1.706-1.195",
    stroke: "#fff",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
};
export default SvgTravel;